import { render, staticRenderFns } from "./indexHexinSwiper.vue?vue&type=template&id=e2e05b54&scoped=true&"
import script from "./indexHexinSwiper.vue?vue&type=script&lang=js&"
export * from "./indexHexinSwiper.vue?vue&type=script&lang=js&"
import style1 from "./indexHexinSwiper.vue?vue&type=style&index=1&id=e2e05b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e05b54",
  null
  
)

export default component.exports